export const SITE_ORIGIN = 'https://linoludovic.fr';
export const SITE_NAME = 'Lino Ludovic';
export const DEFAULT_OG_IMAGE = '/images/HOMEFULLPAGE.jpg';
export const SOCIAL_PROFILES = [
  'https://www.instagram.com/linoludovic/?hl=fr',
  'https://www.tiktok.com/@linoludovic',
  'https://fr.pinterest.com/linoludovic/',
  'https://www.facebook.com/linoludovic/'
];

// Business contact details for JSON-LD ProfessionalService
export const BUSINESS = {
  name: 'Lino Ludovic',
  email: 'contact@linoludovic.fr',
  telephone: '+33675783464', // E.164 format
  address: {
    streetAddress: '30 Imp. des Coquelicots',
    postalCode: '42110',
    addressLocality: 'Salvizinet',
    addressCountry: 'FR'
  },
  areaServed: ['FR', 'EU', 'Worldwide']
};
